import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import language from '../../variables/language';

export default function ParticipantSearchSelect({ value, onChange, excludeIds, placeholder }) {
   const [students, setStudents] = useState([]);
   const [query, setQuery] = useState('');
   const [open, setOpen] = useState(false);
   const wrapRef = useRef(null);
   const lang = language[language.lang];

   useEffect(() => {
      axios.get('/api/students', { withCredentials: true })
         .then(response => setStudents(Array.isArray(response.data) ? response.data : []))
         .catch(() => setStudents([]));
   }, []);

   // parent resets value to '' after a successful add - follow it back to a blank search
   useEffect(() => {
      if(!value) {
         setQuery('');
      }
   }, [value]);

   useEffect(() => {
      const handleOutside = (e) => {
         if(wrapRef.current && !wrapRef.current.contains(e.target)) {
            setOpen(false);
         }
      };
      document.addEventListener('mousedown', handleOutside);
      return () => document.removeEventListener('mousedown', handleOutside);
   }, []);

   const excludeSet = new Set((excludeIds || []).map(String));
   const selected = students.find(s => String(s.id) === String(value));

   const filtered = students.filter(s => {
      if(excludeSet.has(String(s.id))) {
         return false;
      }
      if(!query.trim()) {
         return true;
      }
      const haystack = ((s.name || '') + ' ' + (s.surname || '')).toLowerCase();
      return haystack.includes(query.trim().toLowerCase());
   });

   const handlePick = (student) => {
      onChange(String(student.id));
      setQuery(student.name + ' ' + student.surname);
      setOpen(false);
   }

   const handleInputChange = (e) => {
      setQuery(e.target.value);
      if(value) {
         onChange('');
      }
   }

   const displayValue = open ? query : (selected ? (selected.name + ' ' + selected.surname) : query);

   return (
      <div className='participant-search-select' ref={wrapRef}>
         <input className='submit-field from-input txt-c participant-search-input'
            type='text' placeholder={placeholder}
            value={displayValue}
            onFocus={() => { setOpen(true); setQuery(''); }}
            onChange={handleInputChange} />
         {open ? (
            <div className='participant-search-dropdown'>
               {filtered.length === 0 ? (
                  <div className='participant-search-empty'>{lang['Empty list']}</div>
               ) : filtered.map(s => (
                  <div key={s.id} className='participant-search-option' onClick={() => handlePick(s)}>
                     {s.name} {s.surname}
                  </div>
               ))}
            </div>
         ) : ''}
      </div>
   );
}
